<template>
	<DecksContainer
		:decks="decks"
		:title="$t('dashboard.others.title')"
		:fetch-decks="fetchDecks"
		:request-more-decks="requestMoreDecks"
		:results-amount="resultsAmount"
		:more-link="resultsAmount ? 'others' : ''"
	/>
</template>
<script>
	import DecksContainer from '@/components/dashboard/DecksContainer';

	export default {
		name: 'Others',
		components: {
			DecksContainer,
		},
		props: {
			resultsAmount: {
				type: Number,
				default: null,
			},
		},
		computed: {
			decks() {
				if (typeof this.resultsAmount === 'number') {
					return this.$store.getters.othersLists.slice(0, this.resultsAmount);
				}

				return this.$store.getters.othersLists;
			},
			requestMoreDecks() {
				if (typeof this.resultsAmount === 'number') {
					return;
				}
				return () => this.$store.dispatch('loadMoreOthersLists');
			},
		},
		methods: {
			fetchDecks() {
				return this.$store.dispatch('fetchOthersLists');
			},
		},
	};
</script>
